import { type PortfolioProjectTextCoverStyle } from '#app/__generated__/api.js';

export const isCoverImage = (image: unknown): image is { uid: string } => {
  return image !== null && typeof image === 'object' && 'uid' in image;
};

export const isCoverStyle = (
  coverStyle: unknown,
): coverStyle is { style: PortfolioProjectTextCoverStyle } => {
  return (
    coverStyle !== null &&
    typeof coverStyle === 'object' &&
    'style' in coverStyle
  );
};
